import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { BookmarkState } from '@doda/common/src/constants/referredJobDetail/bookmarkState';
import type { ApiResult } from '@doda/common/src/constants/referredJobDetail/apiResult';

/**
 * BookmarkSliceState
 */
export interface BookmarkSliceState {
  bookmarkState: BookmarkState;
  bookmarkedOnOpened: boolean | null;
  bookmarkModalMessageState: { isShow: boolean; apiResult: ApiResult };
}

export const bookmarkSliceInitialState: BookmarkSliceState = {
  bookmarkState: 'default',
  bookmarkedOnOpened: null,
  bookmarkModalMessageState: { isShow: false, apiResult: '' },
};

export const bookmarkSlice = createSlice({
  name: 'referredJobDetailBookmark',
  initialState: bookmarkSliceInitialState,
  reducers: {
    setBookmarkState: (state, action: PayloadAction<BookmarkState>) => {
      state.bookmarkState = action.payload;
    },
    setBookmarkedOnOpened: (state, action: PayloadAction<boolean>) => {
      state.bookmarkedOnOpened = action.payload;
    },
    setBookmarkModalMessageState: (
      state,
      action: PayloadAction<{ isShow: boolean; apiResult: ApiResult }>
    ) => {
      state.bookmarkModalMessageState = action.payload;
    },
    hideBookmarkModalMessageIfShown: (state) => {
      if (state.bookmarkModalMessageState.isShow)
        state.bookmarkModalMessageState.isShow = false;
    },
  },
});

// Create Action
export const {
  setBookmarkState,
  setBookmarkedOnOpened,
  setBookmarkModalMessageState,
  hideBookmarkModalMessageIfShown,
} = bookmarkSlice.actions;

// Reducer
export const bookmarkReducer = bookmarkSlice.reducer;

/**
 * ルートステートを示すインターフェース
 * @interface RootState
 */
interface RootState {
  bookmark: BookmarkSliceState;
}

// Selector
/**
 * 気になるstateのselector
 * @param state
 * @returns 気になるstate
 */
export const referredJobDetailBookmarkStateSelector = (state: RootState) =>
  state.bookmark.bookmarkState;

/**
 * 画面表示時気になる登録済みかどうかのselector
 * @param state
 * @returns bookmarkedOnOpened
 */
export const referredJobDetailBookmarkedOnOpenedSelector = (state: RootState) =>
  state.bookmark.bookmarkedOnOpened;

/**
 * 気になる登録モーダルメッセージstateのselector
 * @param state
 * @returns 気になる登録モーダルメッセージstate
 */
export const referredJobDetailBookmarkModalMessageState = (state: RootState) =>
  state.bookmark.bookmarkModalMessageState;
